import { createContext, useContext } from 'react';

import { SiteSettings } from '@gn-audio/jss-core';

export const SiteSettingsContext = createContext<SiteSettings>({});

export const useSiteSettings = () => {
  return useContext(SiteSettingsContext);
};
